const API_BASE = process.env.VUE_APP_API_URL || 'https://scamtdtf.com:3000';

export async function apiFetch(path) {
  const res = await fetch(`${API_BASE}${path}`, { method: 'POST' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// Fire-and-forget page view tracking — never throws
export function recordPageVisit(page) {
  fetch(`${API_BASE}/api/recordpagevisit`, {
    method: 'POST',
    headers: { page },
  }).catch(() => {});
}
